module.exports = __webpack_public_path__ + "static/media/coinbaseWalletIcon.62578f59.svg";